import type { FC } from 'react';
import type { SmallMenuItem } from '@/types/menu';
import { TeamLists } from '@/components/raven/Teams/TeamLists';

import styles from './styles.module.css';

export const MegaMenuLeague: FC<{
	child: SmallMenuItem;
}> = ({ child }) => {
	const children = child.children || [];
	const hasChildren = Boolean(children);

	if (!hasChildren) {
		return null;
	}

	const sections = children.map((subChildren) => ({
		id: `${subChildren.id}`,
		items: subChildren.children || [],
		title: subChildren.text,
	}));

	return (
		<TeamLists
			className={styles.teamListsMenu}
			ctaUrl={child.url}
			isInNavigation
			sections={sections}
		/>
	);
};
